export const ADDRESS = "شركه مطعم ثلاث مائه فهرنهايت, Arganya Complex. Shuwaik Industrial area 1, Street 6 building 125 shop 5, Shuwaikh Industrial, Kuwait"
